import { MenuAndContent } from 'app/components/layouts';
import { HideMyEmailPage } from 'app/pages/Faq';
import { ResourceDispatcher } from 'app/pages/ResourcesPage';
import { GuidesPage } from 'app/pages/ResourcesPage/GuidesPage';
import { ManualViewer } from 'app/pages/ResourcesPage/ManualViewer';
import { ResourcesFaultCodesPage } from 'app/pages/ResourcesPage/ResourcesFaultCodesPage';
import { VideoResourcesPage } from 'app/pages/ResourcesPage/VideoResourcesPage';
import React from 'react';
import { Route } from 'react-router-dom';

export default function SharedRoutes() {
  return (
    <>
      <Route
        path="/resources/*"
        element={
          <MenuAndContent>
            <ResourceDispatcher />
          </MenuAndContent>
        }
      />

      <Route
        path="/faultCodes/:model/"
        element={
          <MenuAndContent>
            <ResourcesFaultCodesPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/manual/:model/"
        element={
          <MenuAndContent>
            <ManualViewer />
          </MenuAndContent>
        }
      />

      <Route
        path="/videoResources/:model/"
        element={
          <MenuAndContent>
            <VideoResourcesPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/guides/:model/"
        element={
          <MenuAndContent>
            <GuidesPage />
          </MenuAndContent>
        }
      />

      <Route
        path="/faq/hidemyemail"
        element={
          <MenuAndContent>
            <HideMyEmailPage />
          </MenuAndContent>
        }
      />
    </>
  );
}
